import { render, staticRenderFns } from "./configuration-local-assays-results-modal.vue?vue&type=template&id=04e1f597&scoped=true&"
import script from "./configuration-local-assays-results-modal.ts?vue&type=script&lang=ts&"
export * from "./configuration-local-assays-results-modal.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-local-assays-results-modal.scss?vue&type=style&index=0&id=04e1f597&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e1f597",
  null
  
)

export default component.exports